import { FaTh, FaThList } from "react-icons/fa";

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

export default function Toolbar({data, setSort, setGrid, grid}) {


    //get locale
    const { t } = useTranslation();

    const sortChange = (e) => {
        const value = e.target.value;
        setSort(value);
    }

    return (
        <div className="border w-full rounded-xl p-3 gap-5 grid-cols-12 grid">
            <div className="col-span-6 lg:col-span-1 gap-5">
                <div className="flex h-full items-center">
                    <span className="cursor-pointer" onClick={() => setGrid([4, 3, 6])}>
                        <FaTh className={JSON.stringify(grid) === JSON.stringify([4, 3, 6]) ? 'text-[var(--orange)]' : ''} />
                    </span>
                    <span className="cursor-pointer" onClick={() => setGrid([12, 12, 12])}>
                        <FaThList className={`ms-3 ${JSON.stringify(grid) === JSON.stringify([12, 12, 12]) ? 'text-[var(--orange)]' : ''}`} />
                    </span>
                </div>
            </div>
            <div className="hidden lg:grid lg:col-span-7 gap-5 text-sm">
                <div className="flex items-center pt-1">{t('found')} {data?.data?.total ?? 0} {t('products')}</div>
            </div>
            <div className="col-span-6 lg:col-span-4">
                <select className="w-full" onChange={(e)=>sortChange(e)}>
                    <option value="date-desc">{t('new')}</option>
                    <option value="date-asc">{t('old')}</option>
                    <option value="name-asc">{t('name_a')}</option>
                    <option value="name-desc">{t('name_z')}</option>
                </select>
            </div>
        </div>
    );
}